import BaseService from "./BaseService";

export default class UserAndPermissionService extends BaseService {
    public static getUserEmail(token: string, query: string) {
        return BaseService.sendRequest(
            `${process.env.REACT_APP_API_URL}/authorization/support-staff/${encodeURIComponent(query)}?query=${encodeURIComponent(query)}`,
            {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            },
            undefined,
            true
        );
    }

    public static getUserRoles(token: string) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + '/authorization/support-roles', {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
        }
        );
    }

    public static setUsersRole(token: string, postData: any) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'authorization/assign-support-role', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        })
    }

    public static updateRolePermissions(token: string, postData: any, roleId: string) {
        return BaseService.sendRequest(
            `${process.env.REACT_APP_API_URL}/authorization/role-permission/${roleId}`,
            {
                method: 'PUT',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(postData)
            }
        );
    }

    public static createNewRole(token: string, postData: any) {
        return BaseService.sendRequest(
            `${process.env.REACT_APP_API_URL}/authorization/role-permission`,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(postData)
            }
        );
    }

    public static createUser(token: string, postData: any) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'authorization/support-staff', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        })
    }

    public static getPermissions(token: string, roleId: string) {
        return BaseService.sendRequest(
            `${process.env.REACT_APP_API_URL}/authorization/role-permission/${roleId}`,
            {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            }
        );
    }

}